export default {
  sensorsMonitorTitle: { id: 'sensor_title' },
  sensorSite: { id: 'sites' },
  siteType: { id: 'site_type' },
  sensorType: { id: 'sensor_type' },
  dateRange: { id: 'date_range' },
  date: { id: 'date' },
  summary: { id: 'summary' },
  min: { id: 'min' },
  max: { id: 'max' },
  parameter: { id: 'parameter' },
  mean: { id: 'mean' },
  records: { id: 'records' },
  setLimits: { id: 'set_limits' },
  cancel: { id: 'cancel' },
  save: { id: 'save' },
  limitValue: { id: 'limit_value' },
  successMessage: { id: 'limits_successfully_set' },
  value: { id: 'value' },
  maxLimits: { id: 'max_limits' },
  sensorName: { id: 'sensor_name' },
  allSelected: { id: 'all_selected' },
  listLimitMessage: { id: 'list_limit_message' },
}
